import React from "react";
import { Plus } from "lucide-react";

import { Button } from "../ui/button";

/**
 * Consistent header for every admin master-data page.
 *   • eyebrow  — small taupe uppercase label (optional)
 *   • title    — H1 (translated by caller)
 *   • subtitle — one-line description
 *   • CTA      — primary "Add new" button (optional)
 */
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  actionLabel,
  onAction,
  actionTestId = "page-header-primary-action",
}) {
  return (
    <header className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-taupe">
            {eyebrow}
          </p>
        )}
        <h1
          className="mt-2 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl"
          data-testid="page-header-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 max-w-2xl text-sm text-text-secondary">{subtitle}</p>
        )}
      </div>
      {actionLabel && onAction && (
        <Button
          onClick={onAction}
          data-testid={actionTestId}
          className="bg-charcoal text-white hover:bg-charcoal-soft focus-visible:ring-2 focus-visible:ring-champagne"
          size="lg"
        >
          <Plus className="mr-2 h-4 w-4" />
          {actionLabel}
        </Button>
      )}
    </header>
  );
}
